module.exports = __webpack_public_path__ + "static/media/language.2d95fdb4.jpg";